import React from 'react';
import { IconHeartOutlined } from '@prisjakt/ui/icon/heart-outlined';
import { IconHeartFilled } from '@prisjakt/ui/icon/heart-filled';
import { useAppContext } from 'src/components/app-context';
import { Direction } from '@prisjakt/ui';
import { ButtonIcon, ButtonSize } from '@prisjakt/ui/button';
import {
  StyledTooltip,
  StyledButtonText,
  StyledButton,
} from '../shared-styles';

export const SaveToListButton: React.FC<SaveToListButtonProps> = ({
  isActive,
  onClick,
}) => {
  const { t } = useAppContext();

  return (
    <StyledTooltip
      title={t('product', 'action-button.list-tooltip')}
      placement={Direction.Down}
      zIndex={1}
    >
      <StyledButton
        ariaLabel={t('common', 'button.save')}
        onClick={onClick}
        size={ButtonSize.SMALL}
      >
        <ButtonIcon>
          {isActive ? <IconHeartFilled /> : <IconHeartOutlined />}
        </ButtonIcon>
        <StyledButtonText>{t('common', 'button.save')}</StyledButtonText>
      </StyledButton>
    </StyledTooltip>
  );
};

interface SaveToListButtonProps {
  isActive: boolean;
  onClick?: () => void;
}
